import { t } from "i18next";
import { Util } from "common/util";
import { getMany, softDeleteById } from "services/overtime_type";
import Enum from "common/enums";
import withDataTable from "../withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";

const util = new Util();
const pathName = "/setting/overtime-type";
const columns = [
  {
    title: t("text_no"),
    dataIndex: "id",
    key: "id",
    render: (id, record, index) => {
      const size = new URLSearchParams(document.location.search).get("size");
      const current = new URLSearchParams(document.location.search).get(
        "current"
      );
      let defaultCurrent = 1;
      let defaultPageSize = 10;

      if (current) {
        defaultCurrent = current;
      }

      if (size) {
        defaultPageSize = size;
      }
      return (defaultCurrent - 1) * defaultPageSize + (index + 1);
    },
  },
  {
    title: t("text_name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("text_name_Kh"),
    dataIndex: "nameKH",
    key: "nameKH",
  },
  {
    title: t("text_type"),
    dataIndex: "type",
    key: "type",
    render: (type) => {
      if (type === Enum.OVERTIMETYPE.HOLIDAY) {
        return t("text_holiday");
      } else if (type === Enum.OVERTIMETYPE.NORMAL) {
        return t("text_normal");
      } else if (type === Enum.OVERTIMETYPE.NIGHTSHIFT) {
        return t("text_night_shift");
      } else if (type === Enum.OVERTIMETYPE.DAYOFF) {
        return t("text_day_off");
      } else {
        return t("text_compensation");
      }
    },
  },
  {
    title: t("text_rate"),
    dataIndex: "rate",
    key: "rate",
  },
  {
    title: t("text_time"),
    dataIndex: "time",
    key: "time",
    render: (time, record) => {
      const endTime = util.getTimeClock(record.endTime);
      const startTime = util.getTimeClock(record.startTime);
      return (time = `${startTime} ~ ${endTime}`);
    },
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_over_time_types"),
  showPagination: true,
  columns,
  defaultCurrent,
  defaultPageSize,
  getData,
  handleSearch,
  pathName,
  FormInsertOrUpdate,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  confirmSoftDelete: (id) => softDeleteById(id),
});
